import { render } from "./FormFiles.vue?vue&type=template&id=617c10d0&ts=true"
import script from "./FormFiles.vue?vue&type=script&lang=ts"
export * from "./FormFiles.vue?vue&type=script&lang=ts"

import "./FormFiles.vue?vue&type=style&index=0&id=617c10d0&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__